module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/patient/patient.component.scss
// module id = ./src/app/patient/patient.component.scss
// module chunks = main